import { Repository } from './common/repository.class'
import { RepositoryStrategyEnum } from 'src/shared/enum/repository-strategy.enum'
import { IChangelog, IRelease } from '@shared/interface/model.interface'
import { apiGetChangelog } from '@data/datasource/remote/release.api'
import { dbGetChangelog, dbSetChangelog } from '@data/datasource/local/changelog.database'

class ChangelogRepository extends Repository {
  constructor() {
    super()
  }

  /*****************************************
  *
  * GET FUNCTIONS
  *
  *****************************************/

  // Get changelog
  async getChangelog(forcedStrategy?: RepositoryStrategyEnum): Promise<IChangelog | undefined> {
    const finalStrategy = forcedStrategy != null ? forcedStrategy : this.repositoryStragtegy

    if (finalStrategy === RepositoryStrategyEnum.LOCAL_FIRST) {
      return dbGetChangelog()
        .then(changelog => {
          if (changelog == null) {
            return apiGetChangelog()
              .then(toLocalChangelog => {
                if (toLocalChangelog != null) {
                  dbSetChangelog(toLocalChangelog)
                }

                return toLocalChangelog
              })
          } else {
            apiGetChangelog().then(rel => {
              if (rel != null) {
                dbSetChangelog(rel)
              }
            })
            return changelog
          }
        })
    } else {
      return await apiGetChangelog()
        .then(changelog => {
          if (changelog != null) {
            dbSetChangelog(changelog)
          }

          return changelog
        })
        .catch(() => dbGetChangelog())
    }
  }
}

export default new ChangelogRepository()
